import React from 'react';
import { useFormik, FormikProvider } from 'formik';
import { Container, Button } from 'theme-ui';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import Form from 'components/core/Form';
import Spacer from 'elements/Spacer';
import useAuth from 'hooks/useAuth';

const Verification: React.FC = () => {
  const { verify, resendVerification } = useAuth();
  const history = useHistory();
  const loginForm = useFormik({
    initialValues: {
      code: ''
    },
    validationSchema: Yup.object({
      code: Yup.string().required('Required')
    }),
    onSubmit: async ({ code }, { setFieldError, setSubmitting }) => {
      const { error } = await verify(code);

      if (error) {
        setFieldError('code', error.message || JSON.stringify(error));
        setSubmitting(false);
        return;
      }

      return history.push('/');
    }
  });

  const resendCode = async () => {
    const { result, error } = await resendVerification();
    console.log('res: ', result, 'err: ', error);
  };

  return (
    <Container>
      <FormikProvider value={loginForm}>
        <Form>
          <Form.Error name="code" component="div" />
          <Form.Label>Username</Form.Label>
          <Form.Field type="text" name="code" placeholder="Verification Code" />
          <Spacer size={4} />
          <Button type="submit">Submit</Button>
          <Spacer size={4} />
          <Button variant="secondary" onClick={resendCode}>
            Resend Verification Code
          </Button>
        </Form>
      </FormikProvider>
    </Container>
  );
};

export default Verification;
